// Global audio manager: ensures only one <audio> element plays at a time across the app.
// Usage: before calling audio.play(), call registerAudioPlay(audio) to pause any other active audio.

let currentAudio = null;

export function registerAudioPlay(audio) {
  if (currentAudio && currentAudio !== audio) {
    try { currentAudio.pause(); } catch { /* ignore */ }
  }
  currentAudio = audio;
}

export function clearAudioRegistration(audio) {
  if (currentAudio === audio) {
    currentAudio = null;
  }
}
